import React, { SyntheticEvent } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { ViewType } from '../../../../types';
import { SegmentedControl, Button, IconSvg, helperMargin, Typography } from '@utex/ui-kit';
import {
  getExtraDimHeaderButton,
  getPrimaryDimHeaderButton,
} from '../../../HeaderButtons/buttonsView';
import { Wrapper, Line, Accounts } from './styles';
import { MoneyView } from '../../../MoneyView';
import { Money } from '../../../../types/Money';

interface Props {
  view: ViewType;
  isTooltipVisible: boolean;
  openDeposit: () => void;
  openWithdraw: () => void;
  onAccountsClick: () => void;
  free: Money;
  investedSum: Money;
  grossSum: Money;
}

export const BalanceTooltip: React.FC<Props> = ({
  openDeposit,
  openWithdraw,
  onAccountsClick,
  view,
  isTooltipVisible,
  free,
  investedSum,
  grossSum,
}) => {
  const { t } = useTranslation('header');

  return (
    <CSSTransition in={isTooltipVisible} timeout={300} unmountOnExit={true} classNames="mount">
      <Wrapper>
        <div>
          <Line>
            <Typography.Text>{t('My portfolio')}</Typography.Text>
          </Line>
          <Line>
            <Typography.Text>{t('Free')}</Typography.Text>
            <Typography.Text>
              <MoneyView rule="0-2">{free}</MoneyView>
            </Typography.Text>
          </Line>
          <Line>
            <Typography.Text>{t('Invested')}</Typography.Text>
            <Typography.Text>
              <MoneyView rule="0-2">{investedSum}</MoneyView>
            </Typography.Text>
          </Line>
          <Line>
            <Typography.Text>{t('Current Profit')}</Typography.Text>
            <Typography.Text>
              <MoneyView sign="always" rule="0-2">
                {grossSum}
              </MoneyView>
            </Typography.Text>
          </Line>
          <Line>
            <Accounts
              href="/account"
              onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                onAccountsClick();
              }}
            >
              {t('All accounts')}
            </Accounts>
          </Line>
        </div>
        <SegmentedControl>
          <Button
            as="a"
            view={getPrimaryDimHeaderButton('default')}
            isBlured={view !== 'default'}
            onClick={(e: SyntheticEvent) => {
              e.preventDefault();
              openDeposit();
            }}
            data-gtm="deposit-btn"
          >
            <IconSvg src="plus-thin" width={16} height={16} css={helperMargin({ right: 10 })} />
            {t('Deposit')}
          </Button>
          <Button
            as="a"
            view={getExtraDimHeaderButton('default')}
            isBlured={view !== 'default'}
            onClick={(e: SyntheticEvent) => {
              e.preventDefault();
              openWithdraw();
            }}
          >
            <IconSvg src="minus-thin" width={16} height={16} css={helperMargin({ right: 10 })} />
            {t('Withdraw')}
          </Button>
        </SegmentedControl>
      </Wrapper>
    </CSSTransition>
  );
};
